import { Box, Button, Grid2, Menu, Stack } from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import SideBar from "../SideBar/SideBar";
import { useTheme, useMediaQuery } from "@mui/material";
import "./Assistant.css";
import { TextField, IconButton } from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import Slider from "@mui/material/Slider";
import Switch from "@mui/material/Switch";
import ControlPointOutlinedIcon from "@mui/icons-material/ControlPointOutlined";
import { ToastContainer, toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import SaveIcon from "@mui/icons-material/Save";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";

import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import OutlinedInput from "@mui/material/OutlinedInput";
import Notimage from "../../Images/number-not.png";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import Collapse from "@mui/material/Collapse";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import InputAdornment from "@mui/material/InputAdornment";
import { useLocation } from "react-router-dom";
import {
  createTransferToHuman,
  deleteTransferToHuman,
  getOneAssistant,
  getVoiceList,
  updateOneVoice,
  updateVoiceAssistant,
} from "../../services/Assistant";
import Loader from "../Loader";
import { red } from "@mui/material/colors";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import PauseIcon from "@mui/icons-material/Pause";
import male from "../../Images/Male.png";
import feMale from "../../Images/Female.png";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Chip from "@mui/material/Chip";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";


const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#ECE0FF",
    color: "#747474",
    // maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    // border: '1px solid #dadde9',
    borderRadius: "15px",
    boxShadow: "0px 0px 11px 0px rgba(128, 139, 157, 0.15)",
  },
}));

// Voice4
const ITEM_HEIGHTVoice44 = 40;
const ITEM_PADDING_TOPVoice44 = 8;
const MenuPropsVoice44 = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHTVoice44 * 4.5 + ITEM_PADDING_TOPVoice44,
    },
  },
};
const namesVoice44 = [
  "Oliver Hansen",
  "Van Henry",
  "April Tucker",
  "Ralph Hubbard",
  "Omar Alexander",
  "Carlos Abbott",
  "Miriam Wagner",
  "Bradley Wilkerson",
  "Virginia Andrews",
  "Kelly Snyder",
];
function getStylesVoice44(nameVoice44, personNameVoice44, themeVoice44) {
  return {
    fontWeight: personNameVoice44.includes(nameVoice44)
      ? themeVoice44.typography.fontWeightMedium
      : themeVoice44.typography.fontWeightRegular,
  };
}

// Voice4
const ITEM_HEIGHTVoice4 = 40;
const ITEM_PADDING_TOPVoice4 = 8;
const MenuPropsVoice4 = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHTVoice4 * 4.5 + ITEM_PADDING_TOPVoice4,
    },
  },
};
const namesVoice4 = [
  "Oliver Hansen",
  "Van Henry",
  "April Tucker",
  "Ralph Hubbard",
  "Omar Alexander",
  "Carlos Abbott",
  "Miriam Wagner",
  "Bradley Wilkerson",
  "Virginia Andrews",
  "Kelly Snyder",
];
function getStylesVoice4(nameVoice4, personNameVoice4, themeVoice4) {
  return {
    fontWeight: personNameVoice4.includes(nameVoice4)
      ? themeVoice4.typography.fontWeightMedium
      : themeVoice4.typography.fontWeightRegular,
  };
}
// Voice3
const ITEM_HEIGHTVoice3 = 40;
const ITEM_PADDING_TOPVoice3 = 8;
const MenuPropsVoice3 = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHTVoice3 * 4.5 + ITEM_PADDING_TOPVoice3,
    },
  },
};
const namesVoice3 = [
  "Oliver Hansen",
  "Van Henry",
  "April Tucker",
  "Ralph Hubbard",
  "Omar Alexander",
  "Carlos Abbott",
  "Miriam Wagner",
  "Bradley Wilkerson",
  "Virginia Andrews",
  "Kelly Snyder",
];
function getStylesVoice3(nameVoice3, personNameVoice3, themeVoice3) {
  return {
    fontWeight: personNameVoice3.includes(nameVoice3)
      ? themeVoice3.typography.fontWeightMedium
      : themeVoice3.typography.fontWeightRegular,
  };
}
// Voice2
const ITEM_HEIGHTVoice2 = 40;
const ITEM_PADDING_TOPVoice2 = 8;
const MenuPropsVoice2 = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHTVoice2 * 4.5 + ITEM_PADDING_TOPVoice2,
    },
  },
};
const namesVoice2 = [
  "Oliver Hansen",
  "Van Henry",
  "April Tucker",
  "Ralph Hubbard",
  "Omar Alexander",
  "Carlos Abbott",
  "Miriam Wagner",
  "Bradley Wilkerson",
  "Virginia Andrews",
  "Kelly Snyder",
];
function getStylesVoice2(nameVoice2, personNameVoice2, themeVoice2) {
  return {
    fontWeight: personNameVoice2.includes(nameVoice2)
      ? themeVoice2.typography.fontWeightMedium
      : themeVoice2.typography.fontWeightRegular,
  };
}
const rows = [
  createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
  createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
  createData("Eclair", 262, 16.0, 24, 6.0),
  createData("Cupcake", 305, 3.7, 67, 4.3),
  createData("Gingerbread", 356, 16.0, 49, 3.9),
];
function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#2F024E",
    color: "#fff",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 10,
    border: "none",
    padding: "16px 0px",
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: "rgba(226, 186, 253, 0.30)",
    border: "none",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: "none",
  },
}));

const drawerWidth = 300;

const CreateAssistant = () => {
  const label = { inputProps: { "aria-label": "Switch demo" } };

  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up("sm"));
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));

  const location = useLocation();

  const [age, setAge] = React.useState("");
  const [anchorOrigin, setAnchorOrigin] = useState({
    vertical: "top",
    horizontal: "right",
  });

  // const handleChange = (event) => {
  //   setAge(event.target.value);
  // };

  const [expanded, setExpanded] = React.useState(true);

  const handleAccChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const [isEditing, setIsEditing] = useState(false);
  const [text, setText] = useState("Assitant Name");

  const script = `[Wait for the user response] 



  Understanding Needs: Dive into a conversation about what they're looking for in a Tesla vehicle. 
 
 
 
  Use open-ended questions to gauge their preferences, such as, "What features are you looking for in a car?" or "What's most important to you in a vehicle?
 
 
 
  "Once User tells the requirement, Model Suggestion: Based on their requirements, suggest the most suitable Tesla model. Keep your explanation brief but informative.
 
 
 
  Encourage Test Drive: If the lead shows interest, encourage them to book a test drive. 
 
 
 
  Tell them, "Great choice! Would you like to experience the Model firsthand with a test drive?
 
 
 
  "If user agrees, Information Verification: If a user is willing to book a test drive, politely confirm the customer's details by stating the information you have and asking them to verify it. 
 
 
 
  For example, "I have your name as Nester, email address as abc@gmail.com and your contact number as 6465685669, is that correct?
 
 
 
  "Once User gives personal information,Booking Forwarding: Inform the customer that a Tesla representative will contact them to finalize the test drive details. 
 
 
 
  You might say, "I'm excited you're interested in a test drive. A Tesla representative will reach out shortly to confirm your booking details.
 
 
 
  "Conversation Closure:End the call on a positive note, expressing appreciation for their time and interest.`;

  const [sampleScript, setSampleScript] = useState(script);

  const [isLoading, setIsLoading] = useState(true);

  const handleEditClick = () => {
    setIsEditing(!isEditing);
  };

  const handleEditChange = (event) => {
    setText(event.target.value);
  };

  const handleSave = () => {
    setIsEditing(false);
  };

  const notify = () => toast.success("Updated successfully");
  const navigate = useNavigate();

  const [pop, setPop] = useState(false);
  const handlePopOpen = () => setPop(true);
  const handlePopClose = () => setPop(false);

  // TablePagination-start
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(3);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);

    setPage(0);
  };
  // TablePagination-end

  // Voice5
  const themeVoice44 = useTheme();
  const [personNameVoice44, setPersonNameVoice44] = React.useState([]);
  const handleChangeVoice44 = (event) => {
    const {
      target: { value },
    } = event;
    setPersonNameVoice44(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };
  // Voice4
  const themeVoice4 = useTheme();
  const [personNameVoice4, setPersonNameVoice4] = React.useState([]);
  const handleChangeVoice4 = (event) => {
    const {
      target: { value },
    } = event;
    setPersonNameVoice4(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };
  // Voice3
  const themeVoice3 = useTheme();
  const [personNameVoice3, setPersonNameVoice3] = React.useState([]);
  const handleChangeVoice3 = (event) => {
    const {
      target: { value },
    } = event;
    setPersonNameVoice3(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };
  // Voice2
  const themeVoice2 = useTheme();
  const [personNameVoice2, setPersonNameVoice2] = React.useState([]);
  const handleChangeVoice2 = (event) => {
    const {
      target: { value },
    } = event;
    setPersonNameVoice2(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };
  // expandedMap
  const [sameMap, setsameMap] = React.useState(false);
  const [expandedMap, setExpandedMap] = React.useState(false);

  const handleExpandClickMap = () => {
    setsameMap(false);
    setExpandedMap(!expandedMap);
  };
  const handleExpandClickSameMap = () => {
    setExpandedMap(false);
    setsameMap(!sameMap);
  };
  // expandedMap2
  const [sameMap2, setsameMap2] = React.useState(false);
  const [expandedMap2, setExpandedMap2] = React.useState(false);

  const handleExpandClickMap2 = () => {
    setsameMap2(false);
    setExpandedMap2(!expandedMap2);
  };
  const handleExpandClickSameMap2 = () => {
    setExpandedMap2(false);
    setsameMap2(!sameMap2);
  };

  // expandedMap3
  const [sameMap3, setsameMap3] = React.useState(false);
  const [expandedMap3, setExpandedMap3] = React.useState(false);

  const handleExpandClickMap3 = () => {
    setsameMap3(false);
    setExpandedMap3(!expandedMap3);
  };
  const handleExpandClickSameMap3 = () => {
    setExpandedMap3(false);
    setsameMap3(!sameMap3);
  };

  //  popup
  const [pop1, setPop1] = useState(false);
  const handlePopOpen1 = () => setPop1(true);
  const handlePopClose1 = () => setPop1(false);

  const [pop2, setPop2] = useState(false);
  const handlePopOpen2 = () => setPop2(true);
  const handlePopClose2 = () => setPop2(false);

  const [pop3, setPop3] = useState(false);
  const handlePopOpen3 = () => setPop3(true);
  const handlePopClose3 = () => setPop3(false);

  //  popup2
  const [pop11, setPop11] = useState(false);
  const handlePopOpen11 = () => setPop11(true);
  const handlePopClose11 = () => setPop11(false);

  const [pop22, setPop22] = useState(false);
  const handlePopOpen22 = () => setPop22(true);
  const handlePopClose22 = () => setPop22(false);

  const [pop33, setPop33] = useState(false);
  const handlePopOpen33 = () => setPop33(true);
  const handlePopClose33 = () => setPop33(false);
  //  popup4
  const [pop4, setPop4] = useState(false);
  const handlePopOpen4 = () => setPop4(true);
  const handlePopClose4 = () => setPop4(false);

  //  popup5
  const [pop5, setPop5] = useState(false);
  const handlePopOpen5 = () => setPop5(true);
  const handlePopClose5 = () => setPop5(false);

  //  popup6
  const [pop6, setPop6] = useState(false);
  const handlePopOpen6 = () => setPop6(true);
  const handlePopClose6 = () => setPop6(false);
  //custom code
  const [assistantDetail, setAssistantDetail] = useState({
    assistantId: "",
    appointmentScheduling: "",
    companyName: "",
    engageCount: 2,
    engageMesaage: "",
    lang: "en",
    maxDuration: 13,
    name: "",
    noResponseTime: 30,
    openMsg: "",
    script: "",
    speakfirst: "assitant",
    speech_rate: 15,
    transferToAgent: "",
    voiceId: "",
    voiceName: "Jessica",
    goal: "",
    openMsg: "",
    responseBehaviour: "rapid",
    interuption: false,
    transferToAgent: [],
  });

  const [transferHuman, setTransferHuman] = useState({
    transferName: "",
    description: "",
    phoneNumber: "",
  });
  const [transferStatus, setTransferStatus] = useState(false);

  const [errors, setErrors] = useState({
    assistantId: "",
    appointmentScheduling: "",
    companyName: "",
    engageCount: 2,
    engageMesaage: "",
    lang: "en",
    maxDuration: 13,
    name: "",
    noResponseTime: 30,
    openMsg: "",
    script: "",
    speakfirst: "",
    speech_rate: 15,
    transferToAgent: "",
    voiceId: "",
    voiceName: "Jessica",
    goal: "",
    openMsg: "",
    responseBehaviour: "",
    interuption: false,
    transferName: "",
    description: "",
    phoneNumber: "",
  });

  const [voiceList, setVoiceList] = useState([]);

  const [textFieldColor, setTextFieldColor] = useState("black");
  const [assistantId, setAssistantId] = useState(null);
  const[singleTransferHuman,setSingleTransferHuman]=useState({});

  //delete
  const [authdelete, setAuthdelete] = React.useState(true);
  const [anchorEldelete, setAnchorEldelete] = React.useState(null);
const [numberId,setNumberId]=useState(null);

  useEffect(() => {
    const AssistandDetails = location?.state?.result;
    if (AssistandDetails != undefined) {
      setAssistantDetail(AssistandDetails);
      getAllVoiceList(AssistandDetails);
      setAssistantId(AssistandDetails);
    } else {
      setAssistantDetail({ ...assistantDetail });
    }

    if (location?.state?.id) {
      getAssistendDetail(location.state.id);
      setAssistantId(location.state.id);
    }
  }, []);

  const [anchorEl, setAnchorEl] = useState(null); // State for the dropdown menu position
  const [open, setOpen] = useState(false);
  const options = ["first_name", "last_name", "email"]; // Example options for the autocomplete
  const [oneVoice, setOneVoice] = useState({});

  const [gender, setGender] = useState("all");
  const [filterVoiceList, setFilterVoiceList] = useState([]);

  const [playing, setPlaying] = useState(false);
  // const audioRef = useRef(null);
  // const [loadingPlay, setLoadingPlay] = useState(null);

  const [playingIndex, setPlayingIndex] = useState(null); // Track which audio is playing
  const audioRefs = useRef([]);

  const handleChangeGender = (e) => {
    const value = e.target.value;
    setGender(e.target.value);

    if (value === "all") {
      setFilterVoiceList(voiceList);
    } else {
      const array = voiceList?.filter((item) => item.gender === value);
      setFilterVoiceList(array);
    }
  };

  // Toggle play/pause
  const handlePlayPause = (index, url) => {
    const audio = audioRefs.current[index];

    if (playingIndex === index) {
      // If the same audio is clicked, toggle play/pause
      if (audio.paused) {
        audio.play();
        setPlaying(false);
      } else {
        audio.pause();
        setPlaying(true);
      }
    } else {
      // If a different audio is clicked, stop the currently playing one and play the new one
      if (playingIndex !== null && audioRefs.current[playingIndex]) {
        audioRefs.current[playingIndex].pause();
        setPlaying(false);
      }
      audio.currentTime = 0;
      audio.play();
    }

    // Set the playing index
    setPlayingIndex(index);
  };

  const isPlaying = (index) => {
    const audio = audioRefs.current[index];
    return audio && !audio.paused;
  };

  const handleAudioEnd = (index) => {
    // When audio ends, reset the playing index to null (show play icon again)
    setPlayingIndex(null);
    setPlaying(false);
  };

  const getAssistendDetail = async (id) => {
    setIsLoading(true);
    const response = await getOneAssistant(id);

    if (response?.data?.success === true) {
      var array = response.data.result;

      setTransferStatus(array.transferToAgent.length > 0 ? true : false);
      getAllVoiceList(array.voiceId);
      setAssistantDetail({ ...assistantDetail, ...array });
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  const getAllVoiceList = async (detailId) => {
    setIsLoading(true);
    const response = await getVoiceList();
    if (response?.data?.success === true) {
      setVoiceList(response.data.result);
      setFilterVoiceList(response.data.result);
      response?.data?.result?.map((item) => {
        setIsLoading(true);
        if (detailId === item.voiceID) {
          setOneVoice(item);
          setIsLoading(false);
        }
      });
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  const [load, setLoad] = useState(false);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setAssistantDetail({ ...assistantDetail, [name]: value });
    if (name === "openMsg") {
      if (value?.endsWith("@") && !open) {
        setOpen(true);
        setAnchorEl(e.target); // Set the anchorEl for menu positioning
      } else if (!value?.endsWith("@")) {
        setOpen(false); // Close dropdown if anything other than '@' is typed
      }
    }
  };

  const handleTransferHumanChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setTransferHuman({ ...transferHuman, [name]: value });
  };

  const handleKeyPress = (event) => {
    const phoneNumber = event.target.value;
    // If the pressed key is not a number, "+" or a control key (e.g., backspace)
    if (
      !/[0-9+]/.test(event.key) && // Allow digits or +
      event.key !== "Backspace" // Allow backspace
    ) {
      event.preventDefault(); // Prevent the default action (typing)
    }

    // Handle the special case for "+" at the beginning
    if (event.key === "+" && phoneNumber.includes("+")) {
      event.preventDefault(); // Prevent adding more than one "+"
    }

    // Limit the length of the phone number to 11 characters (1 for "+" and 10 digits)
    if (phoneNumber.length >= 11 && event.key !== "Backspace") {
      event.preventDefault(); // Prevent typing beyond 11 characters
    }
  };

  const validateFocus = (e) => {
    const fieldName = e?.target?.name;
    const fieldValue = e?.target?.value;
    const value = fieldValue?.trim();
    const fieldId = e?.target?.id;

    let isValid = true;
    let errorMessage = "";

    if (value === "" || value === undefined) {
      if (fieldName === "goal") {
        // errorMessage = `Goal is required`;
        // isValid = false;
      }
      if (fieldName === "name") {
        // errorMessage = `Name is required`;
        // isValid = false;
      }
    } else if (fieldName === "goal" && fieldValue.length < 5) {
      errorMessage = `Goal must be 5 characters`;
      isValid = false;
    } else if (fieldName === "name" && fieldValue.length < 5) {
      errorMessage = `Name must be 5 characters`;
      isValid = false;
    } else if (fieldName === "transferName" && fieldValue.length < 5) {
      errorMessage = `Name must be 5 characters`;
      isValid = false;
    } else if (fieldName === "description" && fieldValue.length < 5) {
      errorMessage = `Description must be 5 characters`;
      isValid = false;
    }

    if (fieldId === "speakfirst" && assistantDetail.speakfirst === "") {
      // errorMessage = "pleast select the who speak first";
      // isValid = false;
    }
    if (
      fieldId === "responseBehaviour" &&
      assistantDetail.responseBehaviour === ""
    ) {
      // errorMessage = "pleast select the Assistant response behaviour";
      // isValid = false;
    }

    // Set errors after validation
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: errorMessage,
    }));

    return isValid;
  };

  const handleSelectOption = (option) => {
    setTextFieldColor("red");
    const cursorPosition = assistantDetail?.openMsg.lastIndexOf("@") + 1;
    const updatedValue =
      assistantDetail?.openMsg.slice(0, cursorPosition) +
      option +
      " " +
      assistantDetail?.openMsg.slice(cursorPosition);
    setAssistantDetail({ ...assistantDetail, openMsg: updatedValue });
    setOpen(false);
  };

  const validate = () => {
    let formErrors = {};
    let isValid = true;

    // Validate email
    if (!assistantDetail.name) {
      formErrors.name = "Name is required";
      isValid = false;
    } else if (assistantDetail.name?.length < 5) {
      formErrors.name = "Name must be 5 characters";
      isValid = false;
    }

    if (!assistantDetail.goal) {
      formErrors.goal = "Goal is required";
      isValid = false;
    } else if (assistantDetail.goal?.length < 5) {
      formErrors.goal = "  Goal must be 5 characters";
      isValid = false;
    }
    if (!assistantDetail.speakfirst) {
      formErrors.speakfirst = "  please select who speak first";
      isValid = false;
    }
    if (!assistantDetail.openMsg) {
      formErrors.openMsg = "  Welcome Message is required";
      isValid = false;
    }
    if (!assistantDetail.script) {
      formErrors.script = "Script is required";
      isValid = false;
    }
    if (!assistantDetail.companyName) {
      formErrors.companyName = "Comapny Name is required";
      isValid = false;
    }
    if (!assistantDetail.responseBehaviour) {
      formErrors.responseBehaviour = "Assistant Response Behaviour is required";
      isValid = false;
    }
    if (!assistantDetail.engageMesaage) {
      formErrors.engageMesaage = "Re-Engage Message is required";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };

  const [assistantLoad,setAssistantLoad]=useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setAssistantLoad(true);
      const response = await updateVoiceAssistant(assistantDetail);
      if (response?.data?.success === true) {
        toast.success(response.data.message);
        setAssistantLoad(false);
        // setTimeout(() => {
        //   navigate("/");
        // }, 1000);
      } else {
        toast.error(response?.data?.message);
        setAssistantLoad(false);
      }
    }
  };

  const validateTransfer = () => {
    let formErrors = {};
    let isValid = true;

    // Validate email
    if (!transferHuman.transferName) {
      formErrors.transferName = "Name is required";
      isValid = false;
    } else if (transferHuman.transferName?.length < 5) {
      formErrors.transferName = "Name must be 5 characters";
      isValid = false;
    }

    if (!transferHuman.description) {
      formErrors.description = "Description is required";
      isValid = false;
    } else if (transferHuman.description?.length < 5) {
      formErrors.description = "  Description must be 5 characters";
      isValid = false;
    }

    if (!transferHuman.phoneNumber) {
      formErrors.phoneNumber = "phoneNumber is required";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };

  const handleTransferHumanSubmit = async (e) => {
    e.preventDefault();
    if (validateTransfer()) {
      setLoad(true);
      const data = {
        name: transferHuman.transferName,
        description: transferHuman.description,
        phoneNumber: transferHuman.phoneNumber,
        Id: assistantId,
      };
      const response = await createTransferToHuman(data);
      if (response?.data?.success === true) {
        toast.success(response.data.message);
        setLoad(false);
        handlePopClose2();
        getAssistendDetail(assistantId);
        setTransferHuman({});
        // setTimeout(() => {
        //   navigate("/");
        // }, 1000);
      } else {
        toast.error(response?.data?.message);
        setLoad(false);
      }
    }
  };
  const [loadingRow, setLoadingRow] = useState(null);

  const updateVoice = async (data, valuem, rowIndex) => {
    const detail = {
      voiceId: data?.voiceID,
      Id: assistantDetail.Id,
    };
    setLoad(true);
    setLoadingRow(rowIndex);
    const response = await updateOneVoice(detail);
    if (response?.data?.success === true) {
      toast.success(response.data.message);
      setLoad(false);
      getAllVoiceList(data?.voiceID);
      setLoadingRow(null);
    } else {
      toast.error(response?.data?.message);
      setLoad(false);
      setLoadingRow(null);
    }
  };

  const handleTransferOpen=(data)=>{
    setIsLoading(true);
    handlePopOpen3();
    setSingleTransferHuman(data);
    setIsLoading(false);

  }



  const handleMenudelete = (event,numberId) => {
    setNumberId(numberId)
    setAnchorEldelete(event.currentTarget);
  };

  const handleClosedelete = () => {
    setAnchorEldelete(null);
  };

   const handleDelete = async () => {
      const data = {
        Id:assistantId,
        ttaId:numberId
      };
      setLoad(true);
      const response = await deleteTransferToHuman(data);
      if (response?.data?.success === true) {
       
        toast.success(response.data.message);
        handleClosedelete();
        getAssistendDetail(assistantId);
        setLoad(false);
      } else {
        toast.error(response?.data?.message);
        setLoad(false);
  
        // setPop(false)
      }
    };
  // if (!assistantDetail?.speakfirst && !assistantDetail.responseBehaviour) {
  //   return <Loader />;
  // }
  return (
    <div className="dashboard">
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        // transition={Bounce}
      />
      {/* <Box sx={{ display: isLgUp ? "flex" : "block", marginTop: "20px" }}>
        <SideBar /> */}
      {!assistantDetail?.speakfirst &&
        !assistantDetail.responseBehaviour &&
        oneVoice?.name === undefined &&
        isLoading === true && <Loader />}
      {oneVoice?.name === undefined && <Loader />}

      {/* {!assistantDetail?.speakfirst && <Loader />} */}

      {/* <Box  
          component="main"
          sx={{
            flexGrow: 1,
            p: isLgUp ? 5 : 1,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            marginTop: isLgUp ? "0px" : "80px",
          }}
        > */}
      <Grid2 container spacing={2} sx={{ justifyContent: "center" }}>
        <Grid2
          item
          size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
          className="mb-20"
        >
          <Stack
            direction="row"
            spacing={2}
            sx={{ justifyContent: "space-between" }}
            className="mt-20"
          >
            <div className="textname-edit">
              {isEditing ? (
                <TextField
                  variant="outlined"
                  size="small"
                  value={assistantDetail?.name}
                  // onChange={handleEditChange}
                  onBlur={handleSave} // Save on blur as well
                  placeholder="Assistant Name"
                  name="name"
                  onFocus={(e) => validateFocus(e)}
                  onInput={validateFocus}
                  // error={!!errors.name}
                  // helperText={errors.name}
                  onChange={handleChange}
                />
              ) : (
                <>
                  <span>{assistantDetail?.name}</span>
                </>
              )}

              <IconButton
                onClick={handleEditClick}
                color="primary"
                size="small"
                className="edit-icon"
                sx={{ padding: "8px !important" }}
              >
                {isEditing ? (
                  <SaveIcon onClick={notify} />
                ) : (
                  <BorderColorOutlinedIcon />
                )}
              </IconButton>
              <span style={{ color: "red", fontSize: 10 }}>{errors.name}</span>
            </div>

            <div className="Assitant-avatar display-1" onClick={handlePopOpen}>
              <Avatar
                alt="Remy Sharp"
                // src="/static/images/avatar/1.jpg"
                src={oneVoice?.gender === "male" ? male : feMale}
                sx={{ width: 24, height: 24 }}
              />
              <Typography
                variant="h4"
                component="h4"
                sx={{
                  color: "#000",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: "pointer",
                }}
              >
                {/* Jessica */}
                {/* {assistantDetail?.voiceName} */}
                {oneVoice?.name}
              </Typography>
              <ArrowDropDownIcon />
            </div>
          </Stack>

          <div className="assitant-edit">
            <div className="input-common">
              <div className="display-1">
                <label>Goal</label>
                <HtmlTooltip
                  placement="right"
                  title={
                    <React.Fragment>
                      <Typography
                        color="inherit"
                        sx={{ fontSize: "12px", padding: "7px" }}
                      >
                        This will be the main objective that your Al assistant
                        will try to achieve once its in converstation with your
                        contacts
                      </Typography>
                    </React.Fragment>
                  }
                >
                  <InfoRoundedIcon />
                </HtmlTooltip>
              </div>
              <TextField
                fullWidth
                id="fullWidth"
                name="goal"
                value={assistantDetail?.goal}
                onFocus={(e) => validateFocus(e)}
                onInput={validateFocus}
                error={!!errors.goal}
                helperText={errors.goal}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="assitant-edit">
            <div className="input-common mt-20">
              <div className="display-1">
                <label>Who Speaks First</label>
                <HtmlTooltip
                  placement="right"
                  title={
                    <React.Fragment>
                      <Typography
                        color="inherit"
                        sx={{ fontSize: "12px", padding: "7px" }}
                      >
                        Select the option that best suits your preferences and
                        communication requirements.
                      </Typography>
                    </React.Fragment>
                  }
                >
                  <InfoRoundedIcon />
                </HtmlTooltip>
              </div>
              <FormControl fullWidth>
                <Select
                  labelId="demo-simple-select-label"
                  // id="demo-simple-select"
                  id="speakfirst"
                  value={assistantDetail?.speakfirst}
                  // value="assitant"
                  onChange={handleChange}
                  name="speakfirst"
                  onInput={validateFocus}
                  error={!!errors.speakfirst}
                  helperText={errors.speakfirst}

                  // defaultValue="assitant"
                >
                  <MenuItem value="assitant">
                    Assistant Initiate : Assistant begins with your Call Opening
                    Message.
                  </MenuItem>
                  <MenuItem value="user">
                    User Initiate : Assistant remains silent until user speaks
                    first.
                  </MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>

          <div className="assitant-edit">
            <div className="input-common mt-20">
              <div className="display-1">
                <label>Welcome Message </label>
                <HtmlTooltip
                  placement="right"
                  title={
                    <React.Fragment>
                      <Typography
                        color="inherit"
                        sx={{ fontSize: "12px", padding: "7px" }}
                      >
                        This is the first message that your Al assistant will
                        say once the call is picked up.
                      </Typography>
                      <Typography
                        color="inherit"
                        sx={{ fontSize: "12px", padding: "7px" }}
                      >
                        <b>Additional Note:</b> Make use of variables to
                        personalise it for each contact. (type @ in the text box
                        to use it)
                      </Typography>
                    </React.Fragment>
                  }
                >
                  <InfoRoundedIcon />
                </HtmlTooltip>
              </div>
              {/* <TextField fullWidth id="fullWidth" /> */}
              <TextField
                fullWidth
                id="fullWidth"
                value={assistantDetail?.openMsg}
                onChange={handleChange}
                name="openMsg"
                onInput={validateFocus}
                error={!!errors.openMsg}
                helperText={errors.openMsg}
                // sx={{input: { color:textFieldColor}}}
              />

              {/* Display options after '@' is typed */}
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => setOpen(false)}
                getContentAnchorEl={null} // Fixes the positioning of the dropdown
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
              >
                {options.map((option, index) => (
                  <MenuItem
                    key={index}
                    onClick={() => handleSelectOption(option)}
                  >
                    {option}
                  </MenuItem>
                ))}
              </Menu>
            </div>
          </div>

          <div className="speak-first">
            <div className="display-2">
              <div className="input-common mt-20">
                <div className="display-1">
                  <label>Script</label>
                  <HtmlTooltip
                    placement="right"
                    title={
                      <React.Fragment>
                        <Typography
                          color="inherit"
                          sx={{ fontSize: "12px", padding: "7px" }}
                        >
                          Compose a script outlining the dialogue flow of for
                          your assistant's interactions with users. Include
                          prompts, responses, and any relevant actions or
                          decisions the assitant should take based on user
                          input.
                        </Typography>
                      </React.Fragment>
                    }
                  >
                    <InfoRoundedIcon />
                  </HtmlTooltip>
                </div>
              </div>
              <div>
                <Stack direction="row" spacing={5} className="mt-20">
                  <div className="border-graient mt-10">
                    <Button
                      onClick={() =>
                        setAssistantDetail({
                          ...assistantDetail,
                          script: sampleScript,
                        })
                      }
                    >
                      Apply Sample script
                    </Button>
                  </div>
                  <div className="bg-clr mt-10">
                    {/* <Button onClick={handlePopOpen6}>SAVE</Button> */}
                    {/* <Button onClick={handleSubmit}>SAVE</Button> */}
                    {assistantLoad ? (
                      <Button>Processing...</Button>
                    ) : (
                      <Button
                        // onClick={() => {
                        //   navigate("/contact-list-table");
                        // }}
                        onClick={handleSubmit}
                      >
                        Save
                      </Button>
                    )}
                  </div>
                </Stack>
              </div>
            </div>
            <div className="mt-20 scroll-text">
              <TextField
                fullWidth
                id="outlined-multiline-static"
                multiline
                rows={15}
                // defaultValue="Default Value"
                value={assistantDetail?.script}
                name="script"
                onChange={handleChange}
                onInput={validateFocus}
                error={!!errors.script}
                helperText={errors.script}
              />

              {/* TextField to input text */}
              <div></div>

              {/* <div contentEditable='true' dangerouslySetInnerHTML={{ __html: assistantDetail.scripthtml}}></div> */}
            </div>
          </div>
        </Grid2>

        <Grid2
          item
          size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
          className="mb-20"
        >
          <div className="accodion-box">
            <Accordion
              expanded={expanded === "panel1"}
              onChange={handleAccChange("panel1")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                General Settings
              </AccordionSummary>
              <AccordionDetails>
                <div className="assitant-edit">
                  <div className="input-common mt-20">
                    <div className="display-1">
                      <label>Company Name</label>
                      <HtmlTooltip
                        placement="right"
                        title={
                          <React.Fragment>
                            <Typography
                              color="inherit"
                              sx={{ fontSize: "12px", padding: "7px" }}
                            >
                              Enter the name of the company or business which
                              the Al assistant represents.
                            </Typography>
                          </React.Fragment>
                        }
                      >
                        <InfoRoundedIcon />
                      </HtmlTooltip>
                    </div>
                    <TextField
                      fullWidth
                      id="fullWidth"
                      placeholder="Company Name"
                      name="companyName"
                      value={assistantDetail?.companyName}
                      onFocus={(e) => validateFocus(e)}
                      onInput={validateFocus}
                      error={!!errors.companyName}
                      helperText={errors.companyName}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expanded === "panel2"}
              onChange={handleAccChange("panel2")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                Speech Settings
              </AccordionSummary>
              <AccordionDetails>
                <div className="assitant-edit">
                  <div className="input-common mt-20">
                    <div className="display-2">
                      <div className="display-1">
                        <label>Speech Rate</label>
                        <HtmlTooltip
                          placement="right"
                          title={
                            <React.Fragment>
                              <Typography
                                color="inherit"
                                sx={{ fontSize: "12px", padding: "7px" }}
                              >
                                Adjust how fast or slow the voice assistant
                                talks. Set it to your perfect speed for an
                                enjoyable listening experience!
                              </Typography>
                            </React.Fragment>
                          }
                        >
                          <InfoRoundedIcon />
                        </HtmlTooltip>
                      </div>
                      <div>
                        <label>({assistantDetail?.speech_rate})</label>
                      </div>
                    </div>

                    <div>
                      <Slider
                        defaultValue={10}
                        aria-label="Default"
                        valueLabelDisplay="auto"
                        value={assistantDetail?.speech_rate}
                        onChange={handleChange}
                        name="speech_rate"
                        min={-20}
                        max={20}
                      />

                      <div className="input-common mt-20">
                        <div className="display-1">
                          <label>Assistant’s Response Behavior</label>
                          <HtmlTooltip
                            placement="right"
                            title={
                              <React.Fragment>
                                <Typography
                                  color="inherit"
                                  sx={{ fontSize: "12px", padding: "7px" }}
                                >
                                  <b>Rapid Response:</b> Assistant will start
                                  speaking as soon as silence is detected from
                                  the caller's end, without checking if the
                                  customer has fully conveyed their message.
                                  This will have quicker responses from the
                                  assistant.
                                </Typography>
                                <Typography
                                  color="inherit"
                                  sx={{ fontSize: "12px", padding: "7px" }}
                                >
                                  <b>
                                    Thoughtful Response (Contextual Precision):
                                  </b>{" "}
                                  The assistant will prioritize what the
                                  customer is trying to say over silence
                                  detected while the caller is speaking. This
                                  will make responses slower than Rapid
                                  Response.
                                </Typography>
                              </React.Fragment>
                            }
                          >
                            <InfoRoundedIcon />
                          </HtmlTooltip>
                        </div>
                        <FormControl fullWidth>
                          <Select
                            labelId="demo-simple-select-label"
                            id="responseBehaviour"
                            // value={age}
                            value={assistantDetail?.responseBehaviour}
                            // onChange={handleAccChange}
                            name="responseBehaviour"
                            onInput={validateFocus}
                            error={!!errors.responseBehaviour}
                            helperText={errors.responseBehaviour}
                            onChange={handleChange}
                          >
                            <MenuItem value="rapid">Rapid Response</MenuItem>
                            <MenuItem value="Thoughtful">
                              Thoughtful Response (Contextual Precision)
                            </MenuItem>
                            {/* <MenuItem value={20}>Rapid Response</MenuItem>
                                <MenuItem value={30}>Rapid Response</MenuItem> */}
                          </Select>
                        </FormControl>
                      </div>
                      <div>
                        <div className="asstistant-allow display-2 mt-20">
                          <label>Allow Assistant Interuption</label>
                          <div>
                            {" "}
                            <Switch
                              onChange={(e) =>
                                setAssistantDetail({
                                  ...assistantDetail,
                                  interuption: !assistantDetail.interuption,
                                })
                              }
                              checked={assistantDetail.interuption}
                            />
                          </div>
                        </div>
                        <p>
                          If turned on, we are allowing callers to interrupt the
                          assistant while the assistant is speaking. Once
                          interrupted the assistant will stop speaking and
                          listen to what the caller is saying.
                        </p>
                      </div>
                      <div className="display-2">
                        <div className="display-1">
                          <label>No Response Time Limit:</label>
                          <HtmlTooltip
                            placement="right"
                            title={
                              <React.Fragment>
                                <Typography
                                  color="inherit"
                                  sx={{ fontSize: "12px", padding: "7px" }}
                                >
                                  Set how long the assistant waits for the user
                                  to respond during a call. If the user doesn't
                                  reply within this time, the call will end.
                                  (unless re-engagement settings are on in which
                                  case the assistant will attempt to re-engage
                                  with the user)
                                </Typography>
                              </React.Fragment>
                            }
                          >
                            <InfoRoundedIcon />
                          </HtmlTooltip>
                        </div>
                        <div>
                          <label>
                            ({assistantDetail?.noResponseTime}) seconds
                          </label>
                        </div>
                      </div>
                      <Slider
                        className="mt-10"
                        defaultValue={20}
                        aria-label="Default"
                        valueLabelDisplay="auto"
                        value={assistantDetail?.noResponseTime}
                        name="noResponseTime"
                        onChange={handleChange}
                        min={10}
                        max={30}
                      />

                      {/* <div>
                            <div className="asstistant-allow display-2 mt-20">
                              <label>Allow Assistant Interuption</label>
                              <div> <Switch /></div>
                            </div>
                            <p>If turned on, we are allowing callers to interrupt the assistant while the assistant is speaking. Once interrupted the assistant will stop speaking and listen to what the caller is saying.</p>
                          </div> */}

                      <div className="display-2">
                        <div className="display-1">
                          <label>Re-engage Count</label>
                          <HtmlTooltip
                            placement="right"
                            title={
                              <React.Fragment>
                                <Typography
                                  color="inherit"
                                  sx={{ fontSize: "12px", padding: "7px" }}
                                >
                                  Set how many times the assistant will attempt
                                  to re- engage.
                                </Typography>
                              </React.Fragment>
                            }
                          >
                            <InfoRoundedIcon />
                          </HtmlTooltip>
                        </div>
                        <div>
                          <label>({assistantDetail?.engageCount})</label>
                        </div>
                      </div>
                      <Slider
                        defaultValue={3}
                        aria-label="Default"
                        valueLabelDisplay="auto"
                        value={assistantDetail?.engageCount}
                        onChange={handleChange}
                        name="engageCount"
                        min={2}
                        max={5}
                      />

                      <div className="input-common mt-20">
                        <div className="display-1">
                          <label>Re-engage Message</label>
                          <HtmlTooltip
                            placement="right"
                            title={
                              <React.Fragment>
                                <Typography
                                  color="inherit"
                                  sx={{ fontSize: "12px", padding: "7px" }}
                                >
                                  This is the message the assistant will use to
                                  re-engage with the user.
                                </Typography>
                              </React.Fragment>
                            }
                          >
                            <InfoRoundedIcon />
                          </HtmlTooltip>
                        </div>
                        <TextField
                          fullWidth
                          id="fullWidth"
                          placeholder="Company Name"
                          name="engageMesaage"
                          value={assistantDetail?.engageMesaage}
                          onFocus={(e) => validateFocus(e)}
                          onInput={validateFocus}
                          error={!!errors.engageMesaage}
                          helperText={errors.engageMesaage}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expanded === "panel3"}
              onChange={handleAccChange("panel3")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3-content"
                id="panel3-header"
              >
                Call Settings
              </AccordionSummary>
              <AccordionDetails>
                <div className="assitant-edit">
                  <div className="input-common mt-20">
                    <div>
                      <div className="asstistant-allow display-2 mt-20">
                        <div className="display-1">
                          <label>Voicemail</label>
                          <HtmlTooltip
                            placement="right"
                            title={
                              <React.Fragment>
                                <Typography
                                  color="inherit"
                                  sx={{ fontSize: "12px", padding: "7px" }}
                                >
                                  <b>Voicemail Detection:</b> Toggle to enable
                                  or disable answering machine detection for
                                  outbound calls.
                                </Typography>
                                <Typography
                                  color="inherit"
                                  sx={{ fontSize: "12px", padding: "7px" }}
                                >
                                  <b>Enabled:</b> Detects answering machines or
                                  voicemails and disconnects the call without
                                  deducting minutes from your quota.
                                </Typography>
                                <Typography
                                  color="inherit"
                                  sx={{ fontSize: "12px", padding: "7px" }}
                                >
                                  <b>Disabled:</b> All calls proceed without
                                  detection.
                                </Typography>
                              </React.Fragment>
                            }
                          >
                            <InfoRoundedIcon />
                          </HtmlTooltip>
                        </div>
                        <div>
                          {" "}
                          <Switch />
                        </div>
                      </div>
                      <p>
                        Detects answering machines or voicemails and disconnects
                        the call without deducting minutes from your quota.
                      </p>
                    </div>

                    <div className="display-2">
                      <div className="display-1">
                        <label>Max Call Duration:</label>
                        <HtmlTooltip
                          placement="right"
                          title={
                            <React.Fragment>
                              <Typography
                                color="inherit"
                                sx={{ fontSize: "12px", padding: "7px" }}
                              >
                                Set a time limit for your calls. The voice
                                assistant will end the call once this duration
                                is reached.
                              </Typography>
                            </React.Fragment>
                          }
                        >
                          <InfoRoundedIcon />
                        </HtmlTooltip>
                      </div>
                      <div>
                        <label>({assistantDetail?.maxDuration}) minutes</label>
                      </div>
                    </div>

                    <div>
                      <Slider
                        className="mt-10"
                        defaultValue={10}
                        aria-label="Default"
                        valueLabelDisplay="auto"
                        value={assistantDetail?.maxDuration}
                        onChange={handleChange}
                        name="maxDuration"
                        min={5}
                        max={20}
                      />
                    </div>
                    <div className="input-common mt-20">
                      <div className="display-1">
                        <label>Call Ending Message</label>
                        <HtmlTooltip
                          placement="right"
                          title={
                            <React.Fragment>
                              <Typography
                                color="inherit"
                                sx={{ fontSize: "12px", padding: "7px" }}
                              >
                                This is the message the assistant will use to
                                re-engage with the user.
                              </Typography>
                            </React.Fragment>
                          }
                        >
                          <InfoRoundedIcon />
                        </HtmlTooltip>
                      </div>
                      <TextField
                        fullWidth
                        id="fullWidth"
                        placeholder="Company Name"
                        name="engageMesaage"
                        value={assistantDetail?.engageMesaage}
                        onFocus={(e) => validateFocus(e)}
                        onInput={validateFocus}
                        error={!!errors.engageMesaage}
                        helperText={errors.engageMesaage}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expanded === "panel4"}
              onChange={handleAccChange("panel4")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel4-content"
                id="panel4-header"
              >
                Function
              </AccordionSummary>
              <AccordionDetails>
                <div className="assitant-edit">
                  <div className="input-common mt-20">
                    <p>
                      Enable your agent with capabilities such as calendar
                      bookings, call termination...
                    </p>
                    <h5>
                      <strong>
                        No actions added. Click "Add" to create a new action.
                      </strong>
                    </h5>
                    <div className="transfer-book mt-20">
                      <div className="display-2">
                        <div>
                          <div className="display-1">
                            <label>Transfer to Human</label>
                            <HtmlTooltip
                              placement="right"
                              title={
                                <React.Fragment>
                                  <Typography
                                    color="inherit"
                                    sx={{
                                      fontSize: "12px",
                                      padding: "7px",
                                    }}
                                  >
                                    During call if the contact wishes to talk to
                                    human, we will forward the call to these
                                    number(s). The call will be tried with all
                                    the number(s) but only connected with the
                                    first agent who picks up the call.
                                  </Typography>
                                </React.Fragment>
                              }
                            >
                              <InfoRoundedIcon />
                            </HtmlTooltip>
                          </div>
                          <br />
                        </div>

                        <div>
                          {" "}
                          <Switch
                         checked={transferStatus}
                            onClick={()=>setTransferStatus(!transferStatus)}
                          />
                        </div>
                      </div>
                      <Collapse in={transferStatus} timeout="auto" unmountOnExit>
                      {assistantDetail?.transferToAgent?.length>0 && 
                      assistantDetail?.transferToAgent?.map((item,index)=>{
                     return(
                      <Grid2
                      container
                      spacing={2}
                      sx={{
                        alignItems: "center",
                        background: "#fff",
                        padding: "8px 10px",
                        borderRadius: "12px",
                      }}
                      className="mt-10"
                    >
                      <Grid2
                        item
                        size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}
                      >
                        <Typography
                          id="modal-modal-title"
                          variant="h6"
                          component="h6"
                          sx={{ fontSize: "14px", fontWeight: "600" }}
                        >
                          {item?.name}
                        </Typography>
                      </Grid2>
                      <Grid2
                        item
                        size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}
                        sx={{ justifyContent: "end" }}
                      >
                        <Stack
                          direction="row"
                          spacing={2}
                          sx={{ justifyContent: "end" }}
                        >
                          <VisibilityIcon onClick={()=>handleTransferOpen(item)} />
                          {/* <DeleteIcon /> */}
                          <DeleteIcon
                                  sx={{ cursor: "pointer" }}
                                  onClick={(e)=>handleMenudelete(e,item?._id)}
                                />
                        </Stack>
                      </Grid2>
                    </Grid2>
                     )
                      })
               
                    
                    }
                       
                        <div className="border-graient Function-button mt-10">
                          <Button
                            onClick={handlePopOpen2}
                            startIcon={<ControlPointOutlinedIcon />}
                          >
                            Add Number
                          </Button>
                        </div>
                        <Menu
                    id="menu-appbar"
                    anchorEl={anchorEldelete}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    open={Boolean(anchorEldelete)}
                    onClose={handleClosedelete}
                  >
                    <div className="Delete-button-popup ">
                      <div className="display-11">
                        <Typography
                          color="inherit"
                          sx={{
                            fontSize: "12px",
                            textAlign: "start",
                            paddingBottom: "10px",
                          }}
                        >
                          <b style={{ display: "flex", gap: "5px" }}>
                            {" "}
                            <span className="red">
                              <ErrorOutlineIcon />
                            </span>{" "}
                            Delete this item
                          </b>
                          Are you sure to delete this item?
                        </Typography>
                      </div>
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{ justifyContent: "center" }}
                        className="assitant-stack"
                      >
                        <div className="border-graient Delete-button mt-10">
                          <Button onClick={() => handleClosedelete()}>
                            NO
                          </Button>
                        </div>
                        <div className="border-graient gradient-bg Delete-button mt-10">
                          {/* <Button onClick={handleDelete}>Yes</Button> */}
                          {load===true ? <Button  sx={{width:"100%"}}  >processing..</Button> :  <Button onClick={handleDelete}>Yes</Button>}

                        </div>
                      </Stack>
                    </div>
                  </Menu>
                      </Collapse>
                    </div>
                 
                    <div className="transfer-book mt-20">
                      {/* <div className="display-2">
                            <div>
                              <div className="display-1">
                                <label>Webhook</label>
                                <HtmlTooltip
                                  placement="right"
                                  title={
                                    <React.Fragment>
                                      <Typography
                                        color="inherit"
                                        sx={{
                                          fontSize: "12px",
                                          padding: "7px",
                                        }}
                                      >
                                        Enter a POST HTTP endpoint to receive
                                        post call data on. This can be any POST
                                        webhook url from services like Zapier,
                                        goHighLevel, your personal service
                                        endpoint etc.
                                      </Typography>
                                      <Typography
                                        color="inherit"
                                        sx={{
                                          fontSize: "12px",
                                          padding: "7px",
                                        }}
                                      >
                                        <b>Use Cases</b>: Can be used for
                                        meeting bookings, Mail/Message(s)
                                        sending, etc.
                                      </Typography>
                                    </React.Fragment>
                                  }
                                >
                                  <InfoRoundedIcon />
                                </HtmlTooltip>
                              </div>
                              <br />
                            </div>

                            <div>
                              {" "}
                              <Switch onClick={handleExpandClickMap2} />
                            </div>
                          </div> */}
                      <Collapse in={expandedMap2} timeout="auto" unmountOnExit>
                        <Grid2
                          container
                          spacing={2}
                          sx={{
                            alignItems: "center",
                            background: "#fff",
                            padding: "8px 10px",
                            borderRadius: "12px",
                          }}
                          className="mt-10"
                        >
                          <Grid2
                            item
                            size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}
                          >
                            <Typography
                              id="modal-modal-title"
                              variant="h6"
                              component="h6"
                              sx={{ fontSize: "14px", fontWeight: "600" }}
                            >
                              Name
                            </Typography>
                          </Grid2>
                          <Grid2
                            item
                            size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}
                            sx={{ justifyContent: "end" }}
                          >
                            <Stack
                              direction="row"
                              spacing={2}
                              sx={{ justifyContent: "end" }}
                            >
                              <VisibilityIcon onClick={handlePopOpen33} />
                              <DeleteIcon />
                            </Stack>
                          </Grid2>
                        </Grid2>
                        <div className="border-graient Function-button mt-10">
                          <Button
                            onClick={handlePopOpen11}
                            startIcon={<ControlPointOutlinedIcon />}
                          >
                            Add
                          </Button>
                        </div>
                      </Collapse>
                    </div>
                    <div className="transfer-book mt-20">
                      <div className="display-2">
                        <div>
                          <div className="display-1">
                            <label>Book A Meeting</label> <Chip label="Beta" />
                            <HtmlTooltip
                              placement="right"
                              title={
                                <React.Fragment>
                                  <Typography
                                    color="inherit"
                                    sx={{
                                      fontSize: "12px",
                                      padding: "7px",
                                    }}
                                  >
                                    This feature ensures a smooth and efficient
                                    way to book your meetings, making the
                                    process as seamless and convenient as
                                    possible.
                                  </Typography>
                                  <Typography
                                    color="inherit"
                                    sx={{
                                      fontSize: "12px",
                                      padding: "7px",
                                    }}
                                  >
                                    <b>SMS Booking</b>
                                  </Typography>
                                  <Typography
                                    color="inherit"
                                    sx={{
                                      fontSize: "12px",
                                      padding: "7px",
                                    }}
                                  >
                                    <ul>
                                      <li>
                                        <Typography
                                          color="inherit"
                                          sx={{
                                            fontSize: "12px",
                                            padding: "7px",
                                            color: "#747474",
                                          }}
                                        >
                                          <b>What it Does:</b> On a call, if a
                                          user wants to book a meeting, they
                                          will receive an SMS with a scheduling
                                          link.
                                        </Typography>
                                      </li>
                                      <li>
                                        <Typography
                                          color="inherit"
                                          sx={{
                                            fontSize: "12px",
                                            padding: "7px",
                                            color: "#747474",
                                          }}
                                        >
                                          <b>Configuration:</b>Customize the
                                          message body. provide the scheduling
                                          link, and set specific phrases
                                          (trigger prompts) that will
                                          automatically initiate the SMS booking
                                          flow during the call.
                                        </Typography>
                                      </li>
                                    </ul>
                                  </Typography>
                                  <Typography
                                    color="inherit"
                                    sx={{
                                      fontSize: "12px",
                                      padding: "7px",
                                    }}
                                  >
                                    <b>Note:</b> This feature is currently in
                                    Beta.
                                  </Typography>
                                </React.Fragment>
                              }
                            >
                              <InfoRoundedIcon />
                            </HtmlTooltip>
                          </div>
                          <br />
                          {/* <span className="display-1 mt-10"> <ControlPointOutlinedIcon /> Add</span> */}
                        </div>

                        <div>
                          {" "}
                          <Switch onClick={handleExpandClickMap3} />
                        </div>
                      </div>
                      <Collapse in={expandedMap3} timeout="auto" unmountOnExit>
                        <label>Book a meeting via calendy</label>
                        {/* <Grid2
                              container
                              spacing={2}
                              sx={{
                                alignItems: "center",
                                background: "#fff",
                                padding: "8px 10px",
                                borderRadius: "12px",
                              }}
                              className="mt-10"
                            >
                              <Grid2
                                item
                                size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}
                              >
                                <Typography
                                  id="modal-modal-title"
                                  variant="h6"
                                  component="h6"
                                  sx={{ fontSize: "14px", fontWeight: "600" }}
                                >
                                  Name
                                </Typography>
                              </Grid2>
                              <Grid2
                                item
                                size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}
                                sx={{ justifyContent: "end" }}
                              >
                                <Stack
                                  direction="row"
                                  spacing={2}
                                  sx={{ justifyContent: "end" }}
                                >
                                  <VisibilityIcon onClick={handlePopOpen4} />
                                  <DeleteIcon />
                                </Stack>
                              </Grid2>
                            </Grid2>
                            <div className="border-graient Function-button mt-10">
                              <Button
                                onClick={handlePopOpen4}
                                startIcon={<ControlPointOutlinedIcon />}
                              >
                                Add
                              </Button>
                            </div>
                            <div className="border-graient Function-button mt-10">
                              <Button onClick={handlePopOpen5}>Change</Button>
                            </div> */}
                      </Collapse>
                    </div>
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
        </Grid2>

        <div className="graient-btn text-center">
          <Button
            onClick={() => {
              navigate("/");
            }}
          >
            Test Your assistant
          </Button>
        </div>
      </Grid2>
      {/* </Box> */}

      <div className="modal-popup text-center">
        <Modal
          open={pop}
          onClose={handlePopClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              flexGrow: 1,
              p: isLgUp ? 4 : 1,
              width: { sm: `calc(100% - ${drawerWidth}px)` },
              margin: "0 auto",
              borderRadius: "17px",
              background: "#fff",
              marginTop: isLgUp ? "50px" : "80px",
            }}
          >
            <div className="close-icons-popup1" align="right">
              <HighlightOffIcon onClick={handlePopClose} />
            </div>
            <h3 style={{ color: "#530D80", margin: "0px" }}>Select Voice</h3>

            <Grid2
              container
              spacing={1}
              sx={{
                alignItems: "center",
                marginTop: "20px",
                height: "80vh",
                overflow: "scroll",
              }}
            >
              <Grid2 item size={{ xs: 12, sm: 6, md: 3, lg: 3, xl: 3 }}>
                <div className="input-common">
                  <label>Gender</label>
                  <FormControl fullWidth>
                    <Select
                      displayEmpty
                      // value={personNameVoice3}
                      // onChange={handleChangeVoice3}
                      value={gender}
                      onChange={handleChangeGender}
                      input={<OutlinedInput />}
                      // renderValue={(selected) => {
                      //   if (selected.length === 0) {
                      //     return <em>Select Gender</em>;
                      //   }

                      //   return selected.join(", ");
                      // }}
                      MenuProps={MenuPropsVoice3}
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      <MenuItem value="all">All</MenuItem>
                      <MenuItem value="male">Male</MenuItem>
                      <MenuItem value="female">Female</MenuItem>
                      {/* {namesVoice3.map((nameVoice3) => (
                          <MenuItem
                            key={nameVoice3}
                            value={nameVoice3}
                            style={getStylesVoice2(
                              setPersonNameVoice2,
                              personNameVoice3,
                              themeVoice3
                            )}
                          >
                            {nameVoice3}
                          </MenuItem>
                        ))} */}
                    </Select>
                  </FormControl>
                </div>
              </Grid2>

              <Grid2 item size={{ xs: 12, sm: 6, md: 3, lg: 3, xl: 3 }}>
                <div className="input-common">
                  <label>Voice Provider</label>
                  <FormControl fullWidth>
                    <Select
                      displayEmpty
                      // value={personNameVoice2}
                      value={"elevenlabs"}
                      onChange={handleChangeVoice2}
                      input={<OutlinedInput />}
                      // renderValue={(selected) => {
                      //   if (selected.length === 0) {
                      //     return <em>ElevenLabs</em>;
                      //   }

                      //   return selected.join(", ");
                      // }}
                      MenuProps={MenuPropsVoice2}
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      <MenuItem value="elevenlabs">ElevenLabs</MenuItem>
                      {/* {namesVoice2.map((nameVoice2) => (
                          <MenuItem
                            key={nameVoice2}
                            value={nameVoice2}
                            style={getStylesVoice3(
                              setPersonNameVoice2,
                              personNameVoice2,
                              themeVoice2
                            )}
                          >
                            {nameVoice2}
                          </MenuItem>
                        ))} */}
                    </Select>
                  </FormControl>
                </div>
              </Grid2>
              <Grid2
                item
                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                sx={{
                  boxShadow: " 0px 7.941px 19.059px 0px rgba(0, 0, 0, 0.25)",
                  background: "rgba(226, 186, 253, 0.30)",
                  borderRadius: "9px",
                }}
                className="mt-20 mb-20"
              >
                <div className="chosen-accent-main">
                  <Typography
                    variant="h6"
                    component="h6"
                    sx={{ fontSize: "16px" }}
                  >
                    Chosen Accent
                  </Typography>
                  <div className="display-1">
                    {" "}
                    <Avatar
                      // alt="Remy Sharp"
                      src={oneVoice?.gender === "male" ? male : feMale}
                    />{" "}
                    <Typography
                      variant="h6"
                      component="h6"
                      sx={{ fontSize: "16px" }}
                    >
                      {/* Jessica */}
                      {oneVoice?.name}
                    </Typography>
                  </div>
                  <Typography
                    variant="h6"
                    component="h6"
                    sx={{ fontSize: "16px" }}
                  >
                    {/* ElevenLabs */}
                    {oneVoice?.ttsProvider}
                  </Typography>
                  <Typography
                    variant="h6"
                    component="h6"
                    sx={{ fontSize: "16px" }}
                  >
                    {oneVoice?.gender}
                  </Typography>
                  <Typography
                    variant="h6"
                    component="h6"
                    sx={{ fontSize: "16px" }}
                  >
                    en
                  </Typography>
                </div>
              </Grid2>
              <Grid2
                item
                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                className="mb-20"
              >
                <div className="ContactListTable-main">
                  <TableContainer
                    component={Paper}
                    sx={{ maxHeight: 440, borderRadius: "20px 20px 0px 0px" }}
                  >
                    <Table
                      sx={{ minWidth: 700 }}
                      stickyHeader
                      aria-label="sticky table"
                    >
                      <TableHead>
                        <TableRow>
                          <StyledTableCell align="center">Name</StyledTableCell>
                          <StyledTableCell align="center">
                            Avatar
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            Specification
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            Provider
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            Audio Sample
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            Use Voice
                          </StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {/* {voiceList?.length > 0 &&
                            voiceList.map((row, index) => (
                              <StyledTableRow key={index}>
                                <StyledTableCell component="th" align="center">
                                  <Link to="/contact-list-view">
                                    <h4>{row.name}</h4>{" "}
                                  </Link>
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  <Avatar
                                    alt="Remy Sharp"
                                    src="/static/images/avatar/1.jpg"
                                    sx={{
                                      textAlign: "center",
                                      margin: "0 auto",
                                    }}
                                  />{" "}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  <h4>English </h4>
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  <h4>{row.ttsProvider}</h4>
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  <div name={row.preview_url}>
                                    <PlayArrowIcon />
                                  </div>
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {" "}
                                  <div className="View Details">
                                  
                                    {loadingRow === index ? (
                                      <Button disabled>Processing...</Button>
                                    ) : (
                                      <Button
                                        onClick={() =>
                                          updateVoice(
                                            row,
                                            assistantDetail?.Id,
                                            index
                                          )
                                        }
                                      >
                                        Use Voice
                                      </Button>
                                    )}
                                  </div>
                                </StyledTableCell>
                              </StyledTableRow>
                            ))} */}

                        {
                          filterVoiceList?.length > 0 &&
                            filterVoiceList.map((row, index) => (
                              <StyledTableRow key={index}>
                                <StyledTableCell align="center">
                                  <Link to="/contact-list-view">
                                    <h4>{row.name}</h4>{" "}
                                  </Link>
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  <Avatar
                                    alt="Remy Sharp"
                                    // src="/static/images/avatar/1.jpg"
                                    src={row?.gender === "male" ? male : feMale}
                                    sx={{
                                      textAlign: "center",
                                      margin: "0 auto",
                                    }}
                                  />{" "}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  <h4>English </h4>
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  <h4>{row.ttsProvider}</h4>
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  <div name={row.preview_url}>
                                    <div name={row.preview_url}>
                                      {/* <PlayArrowIcon /> */}
                                      <audio
                                        ref={(el) =>
                                          (audioRefs.current[index] = el)
                                        }
                                        src={row?.preview_url}
                                        preload="auto"
                                        onEnded={() => handleAudioEnd(index)}
                                      />

                                      <IconButton
                                        onClick={() =>
                                          handlePlayPause(
                                            index,
                                            row.preview_url
                                          )
                                        }
                                      >
                                        {isPlaying(index) &&
                                        playing === false ? (
                                          <PauseIcon />
                                        ) : (
                                          <PlayArrowIcon />
                                        )}
                                      </IconButton>
                                    </div>
                                  </div>
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {" "}
                                  <div className="View Details">
                                    {/* <Button
                                      onClick={() =>
                                        updateVoice(
                                          row.voiceID,
                                       
                                          index
                                        )
                                      }
                                    >
                                      
                                      Use Voice
                                    </Button> */}
                                    {loadingRow === index ? (
                                      <Button disabled>Processing...</Button>
                                    ) : (
                                      <Button
                                        onClick={() =>
                                          updateVoice(
                                            row,
                                            assistantDetail?.Id,
                                            index
                                          )
                                        }
                                      >
                                        Use Voice
                                      </Button>
                                    )}
                                  </div>
                                  {/* </Link> */}
                                </StyledTableCell>
                              </StyledTableRow>
                            ))
                          // : voiceList.length > 0 &&
                          //   voiceList?.map((row, index) => (
                          //     <StyledTableRow key={index}>
                          //       <StyledTableCell
                          //         component="th"
                          //         align="center"
                          //       >
                          //         <Link to="/contact-list-view">
                          //           <h4>{row.name}</h4>{" "}
                          //         </Link>
                          //       </StyledTableCell>
                          //       <StyledTableCell align="center">
                          //         <Avatar
                          //           alt="Remy Sharp"
                          //           src="/static/images/avatar/1.jpg"
                          //           sx={{
                          //             textAlign: "center",
                          //             margin: "0 auto",
                          //           }}
                          //         />{" "}
                          //       </StyledTableCell>
                          //       <StyledTableCell align="center">
                          //         <h4>English </h4>
                          //       </StyledTableCell>
                          //       <StyledTableCell align="center">
                          //         <h4>{row.ttsProvider}</h4>
                          //       </StyledTableCell>
                          //       <StyledTableCell align="center">

                          //         <div name={row.preview_url}>
                          //           <audio
                          //             ref={(el) =>
                          //               (audioRefs.current[index] = el)
                          //             }
                          //             src={row?.preview_url}
                          //             preload="auto"
                          //             onEnded={() => handleAudioEnd(index)}
                          //           />

                          //           <IconButton
                          //             onClick={() =>
                          //               handlePlayPause(
                          //                 index,
                          //                 row.preview_url
                          //               )
                          //             }
                          //           >
                          //             {isPlaying(index) &&
                          //             playing === false ? (
                          //               <PauseIcon />
                          //             ) : (
                          //               <PlayArrowIcon />
                          //             )}
                          //           </IconButton>
                          //         </div>
                          //       </StyledTableCell>
                          //       <StyledTableCell align="center">
                          //         {" "}
                          //         <div className="View Details">

                          //           {loadingRow === index ? (
                          //             <Button disabled>Processing...</Button>
                          //           ) : (
                          //             <Button
                          //               onClick={() =>
                          //                 updateVoice(
                          //                   row,
                          //                   assistantDetail?.Id,
                          //                   index
                          //                 )
                          //               }
                          //             >
                          //               Use Voice
                          //             </Button>
                          //           )}
                          //         </div>
                          //         {/* </Link> */}
                          //       </StyledTableCell>
                          //     </StyledTableRow>
                          //   ))
                        }
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {/* <div className="Pagination-main">
                      <TablePagination
                        rowsPerPageOptions={[3, 25, 100]}
                        component="div"
                        count={rows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </div> */}
                </div>
              </Grid2>
            </Grid2>
          </Box>
        </Modal>
      </div>

      <div className="modal-popup1">
        <Modal
          open={pop1}
          onClick={handlePopClose1}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            className="common-modal-box create-voice"
            sx={{ padding: "40px" }}
          >
            <div className="">
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                sx={{ textAlign: "center", paddingBottom: "20px" }}
              >
                <div className="close-icons-popup">
                  <HighlightOffIcon onClick={handlePopClose1} />
                </div>
                Transfer to agent
              </Typography>
              <Grid2 container spacing={1}>
                <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                  <div className="border-graient Add-Number-button-agent mt-10">
                    <Button onClick={handlePopOpen2} startIcon={<AddIcon />}>
                      Add Number
                    </Button>
                  </div>
                </Grid2>
                <Grid2
                  item
                  size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                  className="mt-20 mb-20"
                >
                  <div className="input-common Add-Number-button-input">
                    {/* <label>Gender</label> */}
                    <FormControl fullWidth>
                      <Select
                        displayEmpty
                        value={personNameVoice4}
                        onChange={handleChangeVoice4}
                        input={<OutlinedInput />}
                        renderValue={(selected) => {
                          if (selected.length === 0) {
                            return <em>Select Gender</em>;
                          }

                          return selected.join(", ");
                        }}
                        MenuProps={MenuPropsVoice4}
                        inputProps={{ "aria-label": "Without label" }}
                      >
                        <MenuItem disabled value="">
                          {/* <em>Placeholder</em> */}
                        </MenuItem>
                        {namesVoice4.map((nameVoice4) => (
                          <MenuItem
                            key={nameVoice4}
                            value={nameVoice4}
                            style={getStylesVoice4(
                              setPersonNameVoice4,
                              personNameVoice4,
                              themeVoice4
                            )}
                          >
                            {nameVoice4}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </Grid2>
              </Grid2>
            </div>
          </Box>
        </Modal>
      </div>
      <div className="modal-popup2">
        <Modal
          open={pop2}
          onClick={handlePopClose1}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="common-modal-box">
            <div className="close-icons-popup">
              <HighlightOffIcon onClick={handlePopClose2} />
            </div>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Transfer Call
            </Typography>
            <div className="assistant-cnt">
              <div className="input-common Add-Number-button-input mt-20">
                <div className="display-1">
                  <label>Name</label>
                  <HtmlTooltip
                    placement="right"
                    title={
                      <React.Fragment>
                        <Typography
                          color="inherit"
                          sx={{ fontSize: "12px", padding: "7px" }}
                        >
                          Enter a name for this action.
                        </Typography>
                      </React.Fragment>
                    }
                  >
                    <InfoRoundedIcon />
                  </HtmlTooltip>
                </div>
                <TextField
                  fullWidth
                  id="fullWidth"
                  placeholder="transfer_call ( Minimum 2 characters )"
                  name="transferName"
                  value={transferHuman.transferName}
                  onFocus={(e) => validateFocus(e)}
                  onInput={validateFocus}
                  error={!!errors.transferName}
                  helperText={errors.transferName}
                  onChange={(e) => handleTransferHumanChange(e)}
                  type="text"
                  inputProps={{ inputMode: "text" }}
                />
              </div>

              <div className="input-common Add-Number-button-input mt-20">
                <div className="display-1">
                  <label>Description </label>
                  <HtmlTooltip
                    placement="right"
                    title={
                      <React.Fragment>
                        <Typography
                          color="inherit"
                          sx={{ fontSize: "12px", padding: "7px" }}
                        >
                          Provide a detailed description for this action.
                        </Typography>
                      </React.Fragment>
                    }
                  >
                    <InfoRoundedIcon />
                  </HtmlTooltip>
                </div>
                <TextField
                  multiline
                  rows={5}
                  fullWidth
                  id="fullWidth"
                  placeholder="Briefly describe this function for team reference (e.g., 'Transfer to agent when user requests help'). This is not a trigger or prompt."
                  name="description"
                  value={transferHuman.description}
                  onFocus={(e) => validateFocus(e)}
                  onInput={validateFocus}
                  error={!!errors.description}
                  helperText={errors.description}
                  onChange={(e) => handleTransferHumanChange(e)}
                  type="text"
                  inputProps={{ inputMode: "text" }}
                />
              </div>
            </div>
            <div className="input-common Add-Number-button-input mt-20">
              <div className="display-1">
                <label>Number</label>
                <HtmlTooltip
                  placement="right"
                  title={
                    <React.Fragment>
                      <Typography
                        color="inherit"
                        sx={{ fontSize: "12px", padding: "7px" }}
                      >
                        Specify the phone number to transfer the call to.)
                      </Typography>
                    </React.Fragment>
                  }
                >
                  <InfoRoundedIcon />
                </HtmlTooltip>
              </div>
              <TextField
                fullWidth
                id="fullWidth"
                name="phoneNumber"
                value={transferHuman.phoneNumber}
                onFocus={(e) => validateFocus(e)}
                onInput={validateFocus}
                error={!!errors.phoneNumber}
                helperText={errors.phoneNumber}
                onChange={(e) => handleTransferHumanChange(e)}
                onKeyPress={handleKeyPress}
                inputProps={{
                  maxLength: 11,
                }}
                type="tel"
              />
            </div>
            <Stack
              direction="row"
              spacing={2}
              sx={{ justifyContent: "center" }}
              className="mt-20 assitant-stack"
            >
              <div className="border-graient mt-10">
                <Button onClick={()=>{handlePopClose2();setTransferHuman({})}}>Cancel</Button>
              </div>
              <div className="border-graient gradient-bg mt-10">
                {load===true ? <Button>Processing...</Button> :  <Button onClick={handleTransferHumanSubmit}>Add</Button>}
               
              </div>
            </Stack>
          </Box>
        </Modal>
      </div>
      <div className="modal-popup3">
        <Modal
          open={pop3}
          onClick={handlePopClose3}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="common-modal-box" sx={{ paddingBottom: "30px" }}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              sx={{ textAlign: "center", paddingBottom: "20px" }}
            >
              Transfer to agent Details
            </Typography>
            <div className="Transfer-to-agent-Details">
              <Grid2 container spacing={2} className="mt-10">
                <Grid2
                  item
                  size={{ xs: 6, sm: 3.5, md: 3.5, lg: 3.5, xl: 3.5 }}
                >
                  <Typography
                    variant="p"
                    component="p"
                    sx={{ paddingTop: "5px" }}
                  >
                    Name
                  </Typography>
                </Grid2>
                <Grid2 item size={{ xs: 6, sm: 1, md: 1, lg: 1, xl: 1 }}>
                  {" "}
                  <Typography
                    variant="p"
                    component="p"
                    sx={{ paddingTop: "5px" }}
                  >
                    :
                  </Typography>
                </Grid2>

                <Grid2
                  item
                  size={{ xs: 12, sm: 7.5, md: 7.5, lg: 7.5, xl: 7.5 }}
                >
                  <Typography
                    variant="p"
                    component="p"
                    sx={{ paddingTop: "5px" }}
                  >
                    {/* Sam */}
                    {singleTransferHuman?.name}
                  </Typography>
                </Grid2>
              </Grid2>
            </div>
            <div className="Transfer-to-agent-Details">
              <Grid2 container spacing={2} className="mt-10">
                <Grid2
                  item
                  size={{ xs: 6, sm: 3.5, md: 3.5, lg: 3.5, xl: 3.5 }}
                >
                  <Typography
                    variant="p"
                    component="p"
                    sx={{ paddingTop: "5px" }}
                  >
                    Description
                  </Typography>
                </Grid2>
                <Grid2 item size={{ xs: 6, sm: 1, md: 1, lg: 1, xl: 1 }}>
                  {" "}
                  <Typography
                    variant="p"
                    component="p"
                    sx={{ paddingTop: "5px" }}
                  >
                    :
                  </Typography>
                </Grid2>

                <Grid2
                  item
                  size={{ xs: 12, sm: 7.5, md: 7.5, lg: 7.5, xl: 7.5 }}
                >
                  <Typography
                    variant="p"
                    component="p"
                    sx={{ paddingTop: "5px" }}
                  >
                    {/* Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled it to make a
                    type specimen book. It has survived not only five centuries,
                    but also the leap into electronic typesetting,{" "} */}
                                        {singleTransferHuman?.description}

                  </Typography>
                </Grid2>
              </Grid2>
            </div>
            <div className="Transfer-to-agent-Details">
              <Grid2 container spacing={2} className="mt-10">
                <Grid2
                  item
                  size={{ xs: 6, sm: 3.5, md: 3.5, lg: 3.5, xl: 3.5 }}
                >
                  <Typography
                    variant="p"
                    component="p"
                    sx={{ paddingTop: "5px" }}
                  >
                    Phone Number
                  </Typography>
                </Grid2>
                <Grid2 item size={{ xs: 6, sm: 1, md: 1, lg: 1, xl: 1 }}>
                  {" "}
                  <Typography
                    variant="p"
                    component="p"
                    sx={{ paddingTop: "5px" }}
                  >
                    :
                  </Typography>
                </Grid2>

                <Grid2
                  item
                  size={{ xs: 11, sm: 7.5, md: 7.5, lg: 7.5, xl: 7.5 }}
                >
                  <Typography
                    variant="p"
                    component="p"
                    sx={{ paddingTop: "5px" }}
                  >
                    {/* +91 - 25613265985 */}
                    {singleTransferHuman?.phoneNumber}

                  </Typography>
                </Grid2>
              </Grid2>
            </div>
          </Box>
        </Modal>
      </div>

      <div className="modal-popup11">
        <Modal
          open={pop11}
          onClick={handlePopClose11}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            className="common-modal-box create-voice"
            sx={{ padding: "40px" }}
          >
            <div className="close-icons-popup">
              <HighlightOffIcon onClick={handlePopClose11} />
            </div>
            <div className="">
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                sx={{ textAlign: "center", paddingBottom: "20px" }}
              >
                Add Webhook
              </Typography>
              <Grid2 container spacing={1}>
                <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                  <div className="border-graient Add-Number-button-agent mt-10">
                    <Button onClick={handlePopOpen22} startIcon={<AddIcon />}>
                      Add Webhook
                    </Button>
                  </div>
                </Grid2>
                <Grid2
                  item
                  size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                  className="mt-20 mb-20"
                >
                  <div className="input-common Add-Number-button-input">
                    {/* <label>Gender</label> */}
                    <FormControl fullWidth>
                      <Select
                        displayEmpty
                        value={personNameVoice44}
                        onChange={handleChangeVoice44}
                        input={<OutlinedInput />}
                        renderValue={(selected) => {
                          if (selected.length === 0) {
                            return <em>Select Existing Webhooks</em>;
                          }

                          return selected.join(", ");
                        }}
                        MenuProps={MenuPropsVoice44}
                        inputProps={{ "aria-label": "Without label" }}
                      >
                        <MenuItem disabled value="">
                          <em>Select Existing Webhooks</em>
                        </MenuItem>
                        {namesVoice4.map((nameVoice44) => (
                          <MenuItem
                            key={nameVoice44}
                            value={nameVoice44}
                            style={getStylesVoice44(
                              setPersonNameVoice44,
                              personNameVoice44,
                              themeVoice44
                            )}
                          >
                            {nameVoice44}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </Grid2>
              </Grid2>
            </div>
          </Box>
        </Modal>
      </div>
      <div className="modal-popup22">
        <Modal
          open={pop22}
          onClick={handlePopClose11}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="common-modal-box">
            <div className="close-icons-popup">
              <HighlightOffIcon onClick={handlePopClose22} />
            </div>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Webhook Setup
            </Typography>
            <div className="assistant-cnt">
              <div className="input-common Add-Number-button-input mt-20">
                <div className="display-1">
                  <label>Name</label>
                  <HtmlTooltip
                    placement="right"
                    title={
                      <React.Fragment>
                        <Typography
                          color="inherit"
                          sx={{ fontSize: "12px", padding: "7px" }}
                        >
                          Enter a name for this webhook action.
                        </Typography>
                      </React.Fragment>
                    }
                  >
                    <InfoRoundedIcon />
                  </HtmlTooltip>
                </div>
                <TextField
                  fullWidth
                  id="fullWidth"
                  placeholder="webhook_action ( Minimum 2 characters )"
                />
              </div>

              <div className="input-common Add-Number-button-input mt-20">
                <div className="display-1">
                  <label>Description </label>
                  <HtmlTooltip
                    placement="right"
                    title={
                      <React.Fragment>
                        <Typography
                          color="inherit"
                          sx={{ fontSize: "12px", padding: "7px" }}
                        >
                          Provide a detailed description for this webhook
                          action.
                        </Typography>
                      </React.Fragment>
                    }
                  >
                    <InfoRoundedIcon />
                  </HtmlTooltip>
                </div>
                <TextField
                  multiline
                  rows={5}
                  fullWidth
                  id="fullWidth"
                  placeholder="Optional: Enter a brief description of the webhook for reference (e.g., 'Sends user details to a support team."
                />
              </div>
            </div>
            <div className="input-common Add-Number-button-input mt-20">
              <div className="display-1">
                <label>Webhook URL</label>
                <HtmlTooltip
                  placement="right"
                  title={
                    <React.Fragment>
                      <Typography
                        color="inherit"
                        sx={{ fontSize: "12px", padding: "7px" }}
                      >
                        Specify the URL for the webhook.
                      </Typography>
                    </React.Fragment>
                  }
                >
                  <InfoRoundedIcon />
                </HtmlTooltip>
              </div>
              <TextField
                fullWidth
                id="fullWidth"
                placeholder="https://example.com/webhook"
              />
            </div>
            <Stack
              direction="row"
              spacing={2}
              sx={{ justifyContent: "center" }}
              className="mt-20 assitant-stack"
            >
              <div className="border-graient mt-10">
                <Button onClick={handlePopClose22}>Cancel</Button>
              </div>
              <div className="border-graient gradient-bg mt-10">
                <Button>Add</Button>
              </div>
            </Stack>
          </Box>
        </Modal>
      </div>
      <div className="modal-popup33">
        <Modal
          open={pop33}
          onClick={handlePopClose33}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="common-modal-box" sx={{ paddingBottom: "30px" }}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              sx={{ textAlign: "center", paddingBottom: "20px" }}
            >
              Webhook Details
            </Typography>
            <div className="Transfer-to-agent-Details">
              <Grid2 container spacing={2} className="mt-10">
                <Grid2
                  item
                  size={{ xs: 6, sm: 3.5, md: 3.5, lg: 3.5, xl: 3.5 }}
                >
                  <Typography
                    variant="p"
                    component="p"
                    sx={{ paddingTop: "5px" }}
                  >
                    Name
                  </Typography>
                </Grid2>
                <Grid2 item size={{ xs: 6, sm: 1, md: 1, lg: 1, xl: 1 }}>
                  {" "}
                  <Typography
                    variant="p"
                    component="p"
                    sx={{ paddingTop: "5px" }}
                  >
                    :
                  </Typography>
                </Grid2>

                <Grid2
                  item
                  size={{ xs: 12, sm: 7.5, md: 7.5, lg: 7.5, xl: 7.5 }}
                >
                  <Typography
                    variant="p"
                    component="p"
                    sx={{ paddingTop: "5px" }}
                  >
                    Sam
                  </Typography>
                </Grid2>
              </Grid2>
            </div>
            <div className="Transfer-to-agent-Details">
              <Grid2 container spacing={2} className="mt-10">
                <Grid2
                  item
                  size={{ xs: 6, sm: 3.5, md: 3.5, lg: 3.5, xl: 3.5 }}
                >
                  <Typography
                    variant="p"
                    component="p"
                    sx={{ paddingTop: "5px" }}
                  >
                    Description
                  </Typography>
                </Grid2>
                <Grid2 item size={{ xs: 6, sm: 1, md: 1, lg: 1, xl: 1 }}>
                  {" "}
                  <Typography
                    variant="p"
                    component="p"
                    sx={{ paddingTop: "5px" }}
                  >
                    :
                  </Typography>
                </Grid2>

                <Grid2
                  item
                  size={{ xs: 12, sm: 7.5, md: 7.5, lg: 7.5, xl: 7.5 }}
                >
                  <Typography
                    variant="p"
                    component="p"
                    sx={{ paddingTop: "5px" }}
                  >
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled it to make a
                    type specimen book. It has survived not only five centuries,
                    but also the leap into electronic typesetting,{" "}
                  </Typography>
                </Grid2>
              </Grid2>
            </div>
            <div className="Transfer-to-agent-Details">
              <Grid2 container spacing={2} className="mt-10">
                <Grid2
                  item
                  size={{ xs: 6, sm: 3.5, md: 3.5, lg: 3.5, xl: 3.5 }}
                >
                  <Typography
                    variant="p"
                    component="p"
                    sx={{ paddingTop: "5px" }}
                  >
                    Webhook URL
                  </Typography>
                </Grid2>
                <Grid2 item size={{ xs: 6, sm: 1, md: 1, lg: 1, xl: 1 }}>
                  {" "}
                  <Typography
                    variant="p"
                    component="p"
                    sx={{ paddingTop: "5px" }}
                  >
                    :
                  </Typography>
                </Grid2>

                <Grid2
                  item
                  size={{ xs: 11, sm: 7.5, md: 7.5, lg: 7.5, xl: 7.5 }}
                >
                  <Typography
                    variant="p"
                    component="p"
                    sx={{ paddingTop: "5px" }}
                  >
                    https://example.com/webhook
                  </Typography>
                </Grid2>
              </Grid2>
            </div>
          </Box>
        </Modal>
      </div>

      <div className="modal-popup4 text-center">
        <Modal
          open={pop4}
          onClose={handlePopClose4}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              flexGrow: 1,
              p: isLgUp ? 4 : 1,
              width: { sm: `calc(100% - ${drawerWidth}px)` },
              margin: "0 auto",
              borderRadius: "17px",
              background: "#fff",
              marginTop: isLgUp ? "50px" : "80px",
            }}
          >
            <div className="close-icons-popup1" style={{ textAlign: "end" }}>
              <HighlightOffIcon onClick={handlePopClose4} />
            </div>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              sx={{ textAlign: "center", paddingBottom: "20px" }}
            >
              Set Up Your SMS Booking Template
            </Typography>

            <Grid2
              container
              spacing={1}
              sx={{
                marginTop: "20px",
                height: "70vh",
                overflow: "scroll",
                alignItems: "center",
              }}
            >
              <Grid2
                item
                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                sx={{
                  borderRadius: "10px",
                  background: " #E7E9FF",
                  padding: "20px",
                }}
              >
                <Typography variant="p" component="p" sx={{ fontSize: "14px" }}>
                  During a call, if the user says any of the{" "}
                  <b>
                    specific trigger prompts (e.g., "I'm interested in
                    scheduling a meeting" or "Can we set up an appointment?"),
                    an SMS{" "}
                  </b>{" "}
                  will be sent using themessage body and meeting link you've set
                  up in the template.{" "}
                  <b>Trigger prompts can be customized to suit your needs.</b>
                </Typography>
              </Grid2>
              <Grid2
                item
                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                sx={{
                  borderRadius: "10px",
                  background: " #E7E9FF",
                  padding: "20px",
                }}
                className="mt-10"
              >
                <Typography variant="p" component="p" sx={{ fontSize: "14px" }}>
                  <b>Note: </b>  You don't need to include the meeting link in
                  your message body. It will be automatically added to the end
                  of your message
                </Typography>
              </Grid2>
              <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <div className="Transfer-to-agent-Details">
                  <Grid2
                    container
                    spacing={0}
                    className="mt-10"
                    sx={{ alignItems: "center" }}
                  >
                    <Grid2
                      item
                      size={{ xs: 6, sm: 3.5, md: 3.5, lg: 3.5, xl: 3.5 }}
                    >
                      <div className="display-1">
                        <Typography
                          variant="p"
                          component="p"
                          sx={{ paddingTop: "5px" }}
                        >
                          Template Name *
                        </Typography>
                        <HtmlTooltip
                          placement="right"
                          title={
                            <React.Fragment>
                              <Typography
                                color="inherit"
                                sx={{ fontSize: "12px", padding: "7px" }}
                              >
                                Enter a name for your template. This helps you
                                identify it later.
                              </Typography>
                            </React.Fragment>
                          }
                        >
                          <InfoRoundedIcon />
                        </HtmlTooltip>
                      </div>
                    </Grid2>
                    <Grid2 item size={{ xs: 6, sm: 1, md: 1, lg: 1, xl: 1 }}>
                      {" "}
                      <Typography
                        variant="p"
                        component="p"
                        sx={{ paddingTop: "5px" }}
                      >
                        :
                      </Typography>
                    </Grid2>

                    <Grid2
                      item
                      size={{ xs: 12, sm: 7.5, md: 7.5, lg: 7.5, xl: 7.5 }}
                    >
                      <div className="input-common Add-Number-button-input">
                        <TextField
                          fullWidth
                          id="fullWidth"
                          placeholder="Template Name"
                        />
                      </div>
                    </Grid2>
                  </Grid2>
                </div>

                <div className="Transfer-to-agent-Details">
                  <Grid2
                    container
                    spacing={0}
                    className="mt-10"
                    sx={{ alignItems: "center" }}
                  >
                    <Grid2
                      item
                      size={{ xs: 6, sm: 3.5, md: 3.5, lg: 3.5, xl: 3.5 }}
                    >
                      <div className="display-1">
                        <Typography
                          variant="p"
                          component="p"
                          sx={{ paddingTop: "5px" }}
                        >
                          Message Body *
                        </Typography>
                        <HtmlTooltip
                          placement="right"
                          title={
                            <React.Fragment>
                              <Typography
                                color="inherit"
                                sx={{ fontSize: "12px", padding: "7px" }}
                              >
                                Write the text message that will be sent to the
                                recipient
                              </Typography>
                            </React.Fragment>
                          }
                        >
                          <InfoRoundedIcon />
                        </HtmlTooltip>
                      </div>
                    </Grid2>
                    <Grid2 item size={{ xs: 6, sm: 1, md: 1, lg: 1, xl: 1 }}>
                      {" "}
                      <Typography
                        variant="p"
                        component="p"
                        sx={{ paddingTop: "5px" }}
                      >
                        :
                      </Typography>
                    </Grid2>

                    <Grid2
                      item
                      size={{ xs: 12, sm: 7.5, md: 7.5, lg: 7.5, xl: 7.5 }}
                    >
                      <div className="input-common Add-Number-button-input">
                        <TextField
                          multiline
                          rows={5}
                          fullWidth
                          id="fullWidth"
                          placeholder="Optional: Enter a brief description of the webhook for reference (e.g., 'Sends user details to a support team."
                        />
                      </div>
                    </Grid2>
                  </Grid2>
                </div>

                <div className="Transfer-to-agent-Details">
                  <Grid2
                    container
                    spacing={0}
                    className="mt-10"
                    sx={{ alignItems: "center" }}
                  >
                    <Grid2
                      item
                      size={{ xs: 6, sm: 3.5, md: 3.5, lg: 3.5, xl: 3.5 }}
                    >
                      <div className="display-1">
                        <Typography
                          variant="p"
                          component="p"
                          sx={{ paddingTop: "5px" }}
                        >
                          Meeting Link *
                        </Typography>
                        <HtmlTooltip
                          placement="right"
                          title={
                            <React.Fragment>
                              <Typography
                                color="inherit"
                                sx={{ fontSize: "12px", padding: "7px" }}
                              >
                                Provide a URL link that user can use to schedule
                                a meeting or appointment.
                              </Typography>
                            </React.Fragment>
                          }
                        >
                          <InfoRoundedIcon />
                        </HtmlTooltip>
                      </div>
                    </Grid2>
                    <Grid2 item size={{ xs: 6, sm: 1, md: 1, lg: 1, xl: 1 }}>
                      {" "}
                      <Typography
                        variant="p"
                        component="p"
                        sx={{ paddingTop: "5px" }}
                      >
                        :
                      </Typography>
                    </Grid2>

                    <Grid2
                      item
                      size={{ xs: 12, sm: 7.5, md: 7.5, lg: 7.5, xl: 7.5 }}
                    >
                      <div className="input-common Add-Number-button-input">
                        <TextField
                          fullWidth
                          id="fullWidth"
                          placeholder="https://example.com/webhook"
                        />
                      </div>
                    </Grid2>
                  </Grid2>
                </div>

                <div className="Transfer-to-agent-Details">
                  <Grid2
                    container
                    spacing={0}
                    className="mt-10"
                    sx={{ alignItems: "center" }}
                  >
                    <Grid2
                      item
                      size={{ xs: 6, sm: 3.5, md: 3.5, lg: 3.5, xl: 3.5 }}
                    >
                      <div className="display-1">
                        <Typography
                          variant="p"
                          component="p"
                          sx={{ paddingTop: "5px" }}
                        >
                          Trigger Prompts *
                        </Typography>
                        <HtmlTooltip
                          placement="right"
                          title={
                            <React.Fragment>
                              <Typography
                                color="inherit"
                                sx={{ fontSize: "12px", padding: "7px" }}
                              >
                                Specify phrases or cues that, when mentioned
                                during a call, will prompt the system to send an
                                SMS using this template
                              </Typography>
                            </React.Fragment>
                          }
                        >
                          <InfoRoundedIcon />
                        </HtmlTooltip>
                      </div>
                    </Grid2>
                    <Grid2 item size={{ xs: 6, sm: 1, md: 1, lg: 1, xl: 1 }}>
                      {" "}
                      <Typography
                        variant="p"
                        component="p"
                        sx={{ paddingTop: "5px" }}
                      >
                        :
                      </Typography>
                    </Grid2>

                    <Grid2
                      item
                      size={{ xs: 12, sm: 7.5, md: 7.5, lg: 7.5, xl: 7.5 }}
                    >
                      <div className="input-common Add-Number-button-input">
                        <TextField
                          fullWidth
                          placeholder="Template Name"
                          slotProps={{
                            input: {
                              endAdornment: (
                                <InputAdornment position="end">
                                  {" "}
                                  <div className="border-graient gradient-bg">
                                    <Button sx={{ width: "50px !important" }}>
                                      Add
                                    </Button>
                                  </div>
                                </InputAdornment>
                              ),
                            },
                          }}
                        />
                      </div>
                      <div className="SMS-Booking-add">
                        <Grid2
                          container
                          spacing={2}
                          sx={{
                            alignItems: "center",
                            background: "rgba(226, 186, 253, 0.30)",
                            padding: "8px 10px",
                            borderRadius: "12px",
                          }}
                          className="mt-10"
                        >
                          <Grid2
                            item
                            size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}
                          >
                            <Typography
                              id="modal-modal-title"
                              variant="h6"
                              component="h6"
                              sx={{ fontSize: "14px", fontWeight: "600" }}
                            >
                              Welcome
                            </Typography>
                          </Grid2>
                          <Grid2
                            item
                            size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}
                            sx={{ justifyContent: "end" }}
                          >
                            <Stack
                              direction="row"
                              spacing={2}
                              sx={{ justifyContent: "end" }}
                            >
                              <DeleteIcon />
                            </Stack>
                          </Grid2>
                        </Grid2>
                      </div>
                    </Grid2>
                  </Grid2>
                </div>
              </Grid2>
              <Grid2
                item
                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                sx={{ textAlign: "center" }}
              >
                <div className="border-graient gradient-bg mt-30">
                  <Button>Add</Button>
                </div>
              </Grid2>
            </Grid2>
          </Box>
        </Modal>
      </div>

      <div className="modal-popup5">
        <Modal
          open={pop5}
          onClick={handlePopClose5}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="common-modal-box" sx={{ paddingBottom: "30px" }}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              sx={{ textAlign: "center", paddingBottom: "20px" }}
            >
              Change Template
            </Typography>
            <Grid2 container spacing={1}>
              <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <div className="border-graient Add-Number-button-agent mt-10">
                  <Button disabled>SMS Meeting Booking</Button>
                </div>
              </Grid2>
            </Grid2>
          </Box>
        </Modal>
      </div>
      <div className="modal-popup6">
        <Modal
          open={pop6}
          onClick={handlePopClose6}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="common-modal-box create-voice">
            <div className="">
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Apply Sample Script
              </Typography>
              <div className="assistant-cnt">
                <div className="input-common mt-20">
                  <label>ElevenLabs Api Key *</label>
                  <TextField
                    fullWidth
                    id="fullWidth"
                    placeholder="Enter ElevenLabs Api key"
                  />
                </div>
              </div>
            </div>

            <Stack
              direction="row"
              spacing={2}
              sx={{ justifyContent: "center" }}
              className="mt-20 assitant-stack"
            >
              <div className="border-graient mt-10">
                <Button onClick={handlePopClose6}>Cancel</Button>
              </div>
              <div className="border-graient gradient-bg mt-10">
                <Button>Apply</Button>
              </div>
            </Stack>
          </Box>
        </Modal>
      </div>
      {/* </Box> */}
    </div>
  );
};

export default CreateAssistant;
